import { useEffect } from 'react';

export function useTitle(title) {
    useEffect(() => {
        if (typeof title !== 'string') {
            return;
        }

        const saved = document.title;
        document.title = `Mssg.me - ${title}`;

        return () => {
            document.title = saved;
        };
    }, []);
}
